import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { UpgradeApiClientContext } from '../upgrade-api-client/upgrade.context';
import { SwitchQueriesConfig } from './switch.config';
export const SwitchApiClient = {
  ...createApiClient(SwitchQueriesConfig),
  context: UpgradeApiClientContext
};
//# sourceMappingURL=switch.api-client.js.map